import * as React from "react";
const SvgDoubleCircleFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.251 6.437a6 6 0 1 0 0 11.127A7.97 7.97 0 0 1 8.001 12c0-2.162.857-4.124 2.25-5.563", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 12, r: 6, fill: "currentColor" }));
export default SvgDoubleCircleFill;
